import ProductAutoComplete from "@/components/Filter/productAutocomplete";
import Layout from "@/components/layout";
import Title from "@/components/title";
import { getProducts } from "@/fetch/fetchProduct";
import { exportShopReport } from "@/fetch/fetchStatistics";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import _ from "lodash";
import moment from "moment";
import * as React from "react";
import { useNavigate } from "react-router-dom";
export default function ReportDownloadPage(props) {
  const { open, setOpen } = props;
  const [isDownloading, setIsDownloading] = React.useState(false);

  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [snackSeverity, setSnackSeverity] = React.useState("info");
  const [productOptions, setProductOptions] = React.useState([]);

  const navigate = useNavigate();
  const fetchProduct = async () => {
    const { data: products } = await getProducts();
    setProductOptions(products);
  };
  const handleOnClick = async (api, fileName) => {
    try {
      setIsDownloading(true);
      setSnackMessage("下載中...");
      setSnackSeverity("info");
      setSnackOpen(true);
      await api.then((response) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        setSnackMessage("下載成功");
        setSnackSeverity("success");
        setIsDownloading(false);
      });
    } catch {
      setSnackMessage("下載失敗");
      setSnackSeverity("error");
      setIsDownloading(false);
    }
  };
  React.useEffect(() => {
    fetchProduct();
  }, []);
  const ShopReportForm = () => {
    const [year, setYear] = React.useState(moment());

    const [compareYear, setCompareYear] = React.useState(
      moment().subtract(1, "year"),
    );

    const [selectedProduct, setSelectedProduct] = React.useState([]);
    React.useEffect(() => {
      setSelectedProduct(_.map(productOptions, "id"));
    }, [productOptions]);
    return (
      <Stack direction="row" spacing={2}>
        <ProductAutoComplete
          fullWidth
          selectByCategory
          multiple
          productOptions={productOptions}
          handleOnChange={(value) => {
            setSelectedProduct(value);
          }}
          selectedValue={selectedProduct ?? []}
        ></ProductAutoComplete>
        <DatePicker
          required
          id="startDate"
          name="startDate"
          label="年份"
          maxDate={moment()}
          value={year}
          views={["year"]}
          onChange={(value) => {
            setYear(value);
          }}
          renderInput={(params) => (
            <TextField {...params} sx={{ width: "50%" }} />
          )}
        ></DatePicker>
        <DatePicker
          required
          id="endDate"
          name="endDate"
          label="比較年份"
          maxDate={moment()}
          value={compareYear}
          views={["year"]}
          onChange={(value) => {
            setCompareYear(value);
          }}
          renderInput={(params) => (
            <TextField {...params} sx={{ width: "50%" }} />
          )}
        ></DatePicker>
        <Button
          disabled={isDownloading}
          onClick={() =>
            handleOnClick(
              exportShopReport(year, compareYear, selectedProduct),
              `Shop Report(${moment(year).format("YYYY")} vs ${moment(compareYear).format("YYYY")}).xlsx`,
            )
          }
        >
          下載
        </Button>
      </Stack>
    );
  };
  return (
    <Layout
      header="ReportDownloadPage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
      open={open}
      setOpen={setOpen}
    >
      <Title title={`報告下載`} history={() => navigate(-1)} />
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`shop-report`}
          id={`shop-report`}
        >
          <Typography component="span">店鋪銷售</Typography>
        </AccordionSummary>
        <AccordionDetails>{ShopReportForm()}</AccordionDetails>
      </Accordion>
    </Layout>
  );
}
